// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getReqBrandApi } from "../../Service/Api/RequestBrandApi"
import { getRegBrandList,getErrors } from "../Reducer/RequestBrandReducer"


// Watchers
function* reqBrandListSaga() {
	yield takeEvery("reqBrand_list/getReqBrand", getAllReqBrand)
}

// Sagas
function* getAllReqBrand(action) {
	// console.log(action)
	try {
		const getReqBrand = yield call(getReqBrandApi, action.payload)
		// console.log(getCategories,"ldfgsdgb")

		if (getReqBrand.request.status === 200) {
			yield put(getRegBrandList(getReqBrand))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(reqBrandListSaga)])
}
